//
export default [
	{
		text: 'fecha',
		value: 'date',
		align: 'right',
		format: 'date',
		width: '15%',
	},
	{
		text: 'cuenta',
		value: ({ account }) => account ? `${account.code} - ${account.comment}` : '-',
		input: {
			custom: 'account',
			itemText: ({ code, comment }) => `${code} - ${comment}`,
			itemValue: 'id',
			type: 'select',
			noDataText: 'Sin cuentas',
			renderItems: row => row.index%2 ? [] : row.item.accounts,
			returnObject: true,
		}
	},
	{
		text: 'debe',
		value: 'amount_deb',
		align: 'right',
		format: 'currency',
		width: '15%',
	},
	{
		text: 'haber',
		value: 'amount_crd',
		align: 'right',
		format: 'currency',
		width: '15%',
	},
]